"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.IsFullWidth = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRouterDom = require("react-router-dom");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
let fullWidthID = 0;
let activeFullWidthComponents = [];
let subscribers = [];
function onUpdate() {
  subscribers.forEach(fn => fn());
}
class IsFullWidth extends _react.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      isFullWidth: !!activeFullWidthComponents.length
    });
    _defineProperty(this, "_onUpdate", () => {
      this.setState({
        isFullWidth: !!activeFullWidthComponents.length
      });
    });
    _defineProperty(this, "_render", ({
      staticContext
    }) => {
      return this.props.render(staticContext && staticContext.fullWidth || this.state.isFullWidth);
    });
  }
  componentDidMount() {
    subscribers.push(this._onUpdate);
    if (this.state.isFullWidth !== !!activeFullWidthComponents.length) {
      this.setState({
        isFullWidth: !!activeFullWidthComponents.length
      });
    }
  }
  componentWillUnmount() {
    subscribers = subscribers.filter(fn => fn !== this._onUpdate);
  }
  render() {
    return /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
      render: this._render
    });
  }
}
exports.IsFullWidth = IsFullWidth;
class FullWidth extends _react.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "_id", fullWidthID++);
    _defineProperty(this, "_render", ({
      staticContext
    }) => {
      if (staticContext) {
        staticContext.fullWidth = true;
      }
      return this.props.children;
    });
  }
  componentDidMount() {
    setTimeout(() => {
      activeFullWidthComponents.push(this._id);
      onUpdate();
    }, 100);
  }
  componentWillUnmount() {
    activeFullWidthComponents = activeFullWidthComponents.filter(id => id !== this._id);
    onUpdate();
  }
  render() {
    return /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
      render: this._render
    });
  }
}
var _default = exports.default = FullWidth;